<script>
import ChildParentIncomeRepository from '../../js/repository/ChildParentIncomeRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: ChildParentIncomeRepository.findByChild,
                params: [this.childId],
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
